import { createRouter, createWebHashHistory } from 'vue-router';
import Page from '../components/core/page/Page.vue';
import store from '../store/store';
import config from "@/config";

const routes = [
    { path: config.includeLanguageCodeInUrl ? "/:lang([a-z]{2})?/:id*" :  "/:id*", component: Page }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

let previousRoute = null;


router.isReady().then(() => { 

    // Send page load to Tracking API
    trackPageView(router.currentRoute.value);

    router.beforeEach((to, from, next) => {
        handleNavigationGuard(to, from, next)
    })

    router.afterEach((to, from) => {
         // Send events to Tracking API
         trackPageView(to);
    });
})

function trackPageView(route) {
    // console.log("yo" + JSON.stringify(route))
    let pageName = route.matched[0]?.instances?.default?.getPageData?.name || "Home";
    let openComp = route.matched[0]?.instances?.default?.contentComponents?.[0] || null;
    let pageTitle = openComp ? openComp.title : pageName;
    let type = openComp ? openComp.type : "scene";

    if (app?.api?.Tracking) {
        app.api.Tracking.navigation("page_view", route.fullPath, pageTitle, type);
    } else {
        // Retry until tracker exists
        setTimeout(() => trackPageView(route), 100);
    }
}


function handleNavigationGuard(to, from, next) {
    const storedLanguage = getCurrentLanguage();
    const routeLanguage = to.params.lang;
  
    // If there is no language in the route or if the route language is different from the stored language, redirect
    if (config.includeLanguageCodeInUrl) {
        if(!routeLanguage){ 
            next({ path: `/${storedLanguage}${to.fullPath}`, replace: true });
            return;
        } else if(routeLanguage !== storedLanguage) {
            // If the route changes to another language, simply reload the site to let DataDecorator handle changing the language
            location.reload()
        }
    }

    // Check if route is behind locked hotspot
    if(!app.api.PageManager.isRouteAccessible(to.path)) {
        // Redirect to home scene if access not allowed
        return accessDenied(next)
    }

    // Allow the navigation
    if (store.getters.canNavigate) {
        if(!hasQueryParameters(to) && hasQueryParameters(from)){
            store.commit('setQueryParameters', from.query)
            next({ ...to, query: from.query });
        } else {
            store.commit('setQueryParameters', to.query)
            next()
        }

        // Store the last route
        previousRoute = from;

       

        // app.api.Tracking.navigation("page_view", to.fullPath, "");
        app.api.AudioManager.checkIfAudio(to.fullPath);
    } else {
        // Cancel the navigation
        next(false)
    }
}

// Look up if route has any query parameters
function hasQueryParameters(route) {
    if(route.query)
        return !!Object.keys(route.query).length
}

// Get saved langugage code from localstorage
function getCurrentLanguage() {
    // DEIFs Cookiebot blokkerer første setting af language i Local Storage
    const storedLanguage = localStorage.getItem(config.name) ? JSON.parse(localStorage.getItem(config.name))["lang"] : 'en';
    return storedLanguage || ''; // Return empty string if stored language is null or undefined
}

// Handle access denied, redirect to home
function accessDenied(next) {
    console.log("ACCESS DENIED n\ => Redirecting to home page")
    app.api.PageManager.navigateToHomePage()
    next({path: '/lobby'});
}


export { handleNavigationGuard };
export { previousRoute }
export default router